import styled from 'styled-components';
import { spaceMixin, token } from '@zillow/constellation';

export const StyledTourCardSelectableControls = styled.div`
  display: flex;
  border-top: 1px solid ${token('colors.gray300')};
  padding: ${spaceMixin('sm')} 0;
  margin-bottom: -${spaceMixin('xs')};
  margin-top: ${spaceMixin('xs')};
`;
